<template>
  <div class="profit-and-cash-flow-tabs-wrapper relative">
    <div class="tabs-action-buttons d-flex justify-content-end mb-3">
      <add-dividend
        class="mr-2"
        :disabled="!canEdit"
      />
      <set-cash-cycle
        class="mr-2"
        :disabled="!canEdit"
      />
      <set-income-taxes :disabled="!canEdit" />
    </div>
    <el-tabs
      v-model="activeTab"
      class="tabs"
    >
      <el-tab-pane
        :label="$t('pages.businessGuide.profitAndCashFlow.profitAndLoss')"
        name="first"
        lazy
      >
        <div v-if="activeTab === 'first'" class="bg-white">
          <profit-and-loss-projection v-if="showIncomeAndExpenses" class="pt-4 pb-1" chart-animations />
          <profit-and-cash-flow-charts-placeholder-type v-else no-border />
        </div>
      </el-tab-pane>

      <el-tab-pane
        :label="$t('pages.businessGuide.profitAndCashFlow.cashFlow')"
        name="second"
        lazy
      >
        <div v-if="activeTab === 'second'" class="bg-white">
          <cash-flow-projection v-if="showCashFlow" class="pt-4 pb-1" chart-animations />
          <profit-and-cash-flow-charts-placeholder-type v-else type="breakdown" no-border />
        </div>
      </el-tab-pane>

      <!-- Table -->
      <el-tab-pane
        :label="$t('pages.businessGuide.profitAndCashFlow.summary')"
        name="third"
        lazy
      >
        <div v-if="activeTab === 'third'">
          <div v-if="showIncomeAndExpenses || showCashFlow" class="pt-4 bg-white">
            <profit-and-loss-table v-if="showIncomeAndExpenses" class="mb-4" />
            <cash-flow-table v-if="showCashFlow" />
          </div>
          <ib-charts-placeholder-type v-if="!showIncomeAndExpenses && !showCashFlow" type="table" no-border />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import AddDividend from '@/views/Home/StoryMode/Forecast/ProfitAndCashFlow/AddDividend.vue'
import CashFlowProjection from '@/views/Home/StoryMode/FinancialPlan/Components/Overview/CashFlowProjection.vue'
import CashFlowTable from '@/views/Home/StoryMode/Forecast/ProfitAndCashFlow/Tables/CashFlowTable.vue'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import ProfitAndCashFlowChartsPlaceholderType from '@/views/Home/StoryMode/FinancialPlan/Components/ProfitAndCashFlow/ProfitAndCashFlowChartsPlaceholderType.vue'
import ProfitAndLossProjection from '@/views/Home/StoryMode/FinancialPlan/Components/Overview/ProfitAndLossProjection.vue'
import ProfitAndLossTable from '@/views/Home/StoryMode/Forecast/ProfitAndCashFlow/Tables/ProfitAndLossTable.vue'
import SetCashCycle from '@/views/Home/StoryMode/Forecast/ProfitAndCashFlow/SetCashCycle.vue'
import SetIncomeTaxes from '@/views/Home/StoryMode/Forecast/ProfitAndCashFlow/SetIncomeTaxes.vue'

export default {
  name: 'ProfitAndCashFlowTabs',

  components: {
    ProfitAndCashFlowChartsPlaceholderType,
    AddDividend,
    SetIncomeTaxes,
    SetCashCycle,
    CashFlowTable,
    ProfitAndLossTable,
    CashFlowProjection,
    ProfitAndLossProjection
  },

  mixins: [MixinIdeaRoles],

  data () {
    return {
      activeTab: 'first'
    }
  },

  computed: {
    ...mapState(['idea']),

    showIncomeAndExpenses () {
      return this.idea.storyMode.forecast.revenueStreams.revenueStreams.length !== 0 ||
          this.idea.storyMode.forecast.directCosts.directCosts.length !== 0 ||
          this.idea.storyMode.setUp.staffAndPayrolls.staffAndPayrolls.length !== 0 ||
          this.idea.storyMode.forecast.marketingBudget.marketingElements.length !== 0 ||
          this.idea.storyMode.forecast.otherOverheads.otherOverheads.length !== 0 ||
          this.idea.storyMode.setUp.startupCosts.startupCosts.length !== 0 ||
          this.idea.storyMode.setUp.financing.finances.length !== 0
    },

    showCashFlow () {
      return this.idea.storyMode.forecast.revenueStreams.revenueStreams.length !== 0 ||
          this.idea.storyMode.forecast.directCosts.directCosts.length !== 0 ||
          this.idea.storyMode.setUp.staffAndPayrolls.staffAndPayrolls.length !== 0 ||
          this.idea.storyMode.forecast.marketingBudget.marketingElements.length !== 0 ||
          this.idea.storyMode.forecast.otherOverheads.otherOverheads.length !== 0 ||
          this.idea.storyMode.setUp.startupCosts.startupCosts.length !== 0 ||
          this.idea.storyMode.setUp.financing.finances.length !== 0 ||
          this.idea.storyMode.forecast.profitAndCashFlow.dividends.length !== 0
    }
  }
}
</script>

<style scoped lang="scss">
.profit-and-cash-flow-tabs-wrapper {
  .tabs-action-buttons {
    display: flex;
    justify-content: flex-end;

    @include media-breakpoint-up($md) {
      position: absolute;
      top: -20px;
      right: 0;
      margin-bottom: unset;
    }
  }

  .tabs {
    ::v-deep {
      .el-tabs__content {
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 0 0 8px 8px;
      }
    }
  }

  .button-group {
    display: flex;
    z-index: 1;

    @include media-breakpoint-up($xxl) {
      position: absolute;
      top: -20px;
      right: 0;
    }
  }
}
</style>
